import appRoutes from "../../../constants/appRoutes";

const navigationHelper = {

    refreshPage(): void {

        window.location.reload();
    },
    openConfigInNewTab(id:number): void {
        let route = `${appRoutes.reporting.edit}?id=${id}`;

        window.open(route)?.focus();
    }
}

export default navigationHelper;